<template>
  <div>
    <navbar-component />
    <div class="bg-container">
      <disputes-searchbar-layout :texts="texts"></disputes-searchbar-layout>
      <disputes-content-layout :texts="texts"></disputes-content-layout>
    </div>
    <footer-component />
    <delete-component />
    <whatsapp-component />
  </div>
</template>

<script>
export default {
  name: "DisputesView",
  data() {
    return {
      //VARIABLES
      texts: "",
    };
  },
  beforeMount() {
    this.texts = FILE.disputes[this.selectLanguage];
  },
  methods: {},
  computed: {
    selectLanguage: function () {
      return this.$store.state.language;
    },
  },
  watch: {
    selectLanguage: function () {
      if (this.selectLanguage) {
        this.texts = FILE.disputes[this.selectLanguage];
      }
    },
  },
};
</script>

<style scoped>
.bg-container {
  width: 100%;
  background: #f2f2f4 0% 0% no-repeat padding-box;
  opacity: 1;
  padding-top: 60px;
}
</style>